import { useMemo } from 'react';
import { prop } from 'ramda';
import { useUserSelector, useDeviceSelector, useGameConfigurationSelector } from '@core/js/store/hooks';
import { getTileImage } from '@theme/js/hooks/games/helpers';

import placeholderImage from '@core/js/hooks/games/images/game_placeholder.svg';

type TUseGameImageUrlsProps = {
    code: string,
    sizes?: { width: number, height: number },
    isRoundedCategory: boolean,
}

export const useGameImageUrls = (
    { code, sizes, isRoundedCategory }: TUseGameImageUrlsProps
): string[] => {
    const games = useGameConfigurationSelector(prop('games'));
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    return useMemo(() => {
        const game = games[code];
        const cmsImageUrl = getTileImage(game, sizes, isRoundedCategory, isDesktop, isLoggedIn);

        return [
            cmsImageUrl,
            placeholderImage
        ];
    }, [code, games, isLoggedIn, isRoundedCategory, isDesktop, sizes]);
};
